import { useSelector } from "react-redux";
import useSysSettingActions from "./_actions";

export const useSysSetting = () => {
    const {
        fetchSysSetting,
        updateSysSetting,
    } = useSysSettingActions();

    const sysSetting = useSelector(state => state.member.data);

    return {
        //state
        sysSetting,
        updateSysSetting,

        //actions
        fetchSysSetting,
    }
}

export {default as sysSettingReducer} from './_reducers';